import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

export type FrontNewsMoreRequestData = {
    line_uid: string,
    login: string,
    id: string,
    connect_name: string,
    connect_mail: string,
    connect_phone: string,
};

/**
 * @description LINE ID與帳號擇一傳入,不可模糊查詢
 */
function frontNewsMore(data: FrontNewsMoreRequestData): Promise<DefaultResponseData> {
    return fetchData('api/front_news_more', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

export { frontNewsMore };
